"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineProductFinder;
function AlpineProductFinder() {
    return Alpine.data('productFinder', function () { return ({
        API_URL: '',
        loading: true,
        loadingFilters: true,
        comparisonEnabled: true,
        search: {
            terms: {
                industry: [],
                productCategory: [],
                application: [],
            },
            filters: [],
        },
        filters: [],
        skuProducts: [],
        skuProductNodes: [],
        products: [],
        parentProductIds: [],
        productsForComparison: [],
        init: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // Configure search values and set API URL
                            this.API_URL = '/graphql';
                            this.getDefaultValuesFromDOM();
                            if (!(this.search.terms.productCategory.length === 1)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.fetchFiltersForProductCategory()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: 
                        // Get Products
                        return [4 /*yield*/, this.getResults()];
                        case 3:
                            // Get Products
                            _a.sent();
                            if (!(this.search.terms.productCategory.length === 1)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.updateOptionsForFilter()];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
        // Handle full call to fetch results
        getResults: function (e) {
            return __awaiter(this, void 0, void 0, function () {
                var needsOptionsRefresh;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            needsOptionsRefresh = false;
                            this.loading = true;
                            if ((e === null || e === void 0 ? void 0 : e.srcElement.name) !== 'product_category' && this.search.terms.productCategory.length === 1) {
                                needsOptionsRefresh = true;
                            }
                            if (!((e === null || e === void 0 ? void 0 : e.srcElement.name) === 'product_category' && this.search.terms.productCategory.length === 1)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.fetchFiltersForProductCategory()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, this.fetchProducts()
                                .then(function () {
                                if (_this.search.terms.productCategory.length === 1
                                    && needsOptionsRefresh) {
                                    return _this.updateOptionsForFilter();
                                }
                                return null;
                            })
                                .then(function (options) {
                                if (_this.search.terms.productCategory.length === 1
                                    && _this.skuProductNodes.length > 0
                                    && needsOptionsRefresh) {
                                    _this.assignUpdatedOptionsToFilters(options);
                                }
                            })
                                .catch(function (error) {
                                console.log(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                        case 3:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        // Product funcs
        fetchSKUProducts: function () {
            return __awaiter(this, void 0, void 0, function () {
                var skuProducts;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Running: fetchSKUProducts');
                            this.loading = true;
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQuerySKUProducts)];
                        case 1:
                            skuProducts = _a.sent();
                            return [2 /*return*/, new Promise(function (resolve) {
                                    // If there are no SKU Products found, empty results.
                                    if (!skuProducts) {
                                        console.log('No SKU products found');
                                        _this.skuProducts = [];
                                        _this.skuProductNodes = [];
                                        _this.products = [];
                                        _this.loading = false;
                                        resolve();
                                    }
                                    // Pointless?
                                    _this.skuProducts = skuProducts;
                                    _this.skuProductNodes = skuProducts;
                                    // Pointless?
                                    if (!_this.skuProductNodes) {
                                        _this.skuProducts = [];
                                        _this.skuProductNodes = [];
                                        _this.products = [];
                                        _this.loading = false;
                                        resolve();
                                    }
                                    resolve();
                                })];
                    }
                });
            });
        },
        fetchProducts: function () {
            return __awaiter(this, void 0, void 0, function () {
                var allProducts;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Running: fetchProducts');
                            this.loading = true;
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryProducts)];
                        case 1:
                            allProducts = _a.sent();
                            return [2 /*return*/, new Promise(function (resolve) {
                                    if (!allProducts) {
                                        console.log('No products found');
                                        _this.products = [];
                                        resolve();
                                    }
                                    // Apply client-side filtering
                                    var filteredProducts = allProducts;
                                    // Filter by product category
                                    if (_this.search.terms.productCategory.length > 0) {
                                        filteredProducts = filteredProducts.filter(function (product) {
                                            var _a, _b;
                                            return ((_b = (_a = product.taxProductCategories) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.some(function (category) { return (_this.search.terms.productCategory.includes(_this.decodeTermId(category.id))); }));
                                        });
                                    }
                                    // Filter by industry
                                    if (_this.search.terms.industry.length > 0) {
                                        filteredProducts = filteredProducts.filter(function (product) {
                                            var _a, _b;
                                            return ((_b = (_a = product.taxIndustries) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.some(function (industry) { return (_this.search.terms.industry.includes(_this.decodeTermId(industry.id))); }));
                                        });
                                    }
                                    // Filter by application
                                    if (_this.search.terms.application.length > 0) {
                                        filteredProducts = filteredProducts.filter(function (product) {
                                            var _a, _b;
                                            return ((_b = (_a = product.taxApplications) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.some(function (application) { return (_this.search.terms.application.includes(_this.decodeTermId(application.id))); }));
                                        });
                                    }
                                    // Apply meta filters (if any)
                                    if (Object.keys(_this.search.filters).length > 0) {
                                        filteredProducts = filteredProducts.filter(function (product) { return (Object.entries(_this.search.filters).every(function (_a) {
                                            var _b, _c;
                                            var key = _a[0], value = _a[1];
                                            if (!value || value === 'any')
                                                return true;
                                            var metaValue = (_c = (_b = product.metaData) === null || _b === void 0 ? void 0 : _b.find(function (meta) { return meta.key === "product_attribute_".concat(key); })) === null || _c === void 0 ? void 0 : _c.value;
                                            if (!metaValue)
                                                return false;
                                            // Simple string matching for now
                                            return metaValue.includes(value);
                                        })); });
                                    }
                                    /** Group and sort products by productCategories */
                                    filteredProducts.sort(function (a, b) {
                                        // Check if productCategories is empty.
                                        var aCopy = __assign({}, a);
                                        var bCopy = __assign({}, b);
                                        if (!a.taxProductCategories.nodes.length) {
                                            aCopy = __assign({}, a);
                                            aCopy.taxProductCategories.nodes[0] = { id: 'zzz' };
                                        }
                                        if (!b.taxProductCategories.nodes.length) {
                                            bCopy = __assign({}, b);
                                            bCopy.taxProductCategories.nodes[0] = { id: 'zzz' };
                                        }
                                        var aCategory = aCopy.taxProductCategories.nodes[0].id;
                                        var bCategory = bCopy.taxProductCategories.nodes[0].id;
                                        if (aCategory < bCategory) {
                                            return -1;
                                        }
                                        if (aCategory > bCategory) {
                                            return 1;
                                        }
                                        return 0;
                                    });
                                    // Iterate through all the products, and strip the excerpt of any HTML tags.
                                    filteredProducts.forEach(function (product) {
                                        if (product.excerpt) {
                                            var productCopy = __assign({}, product);
                                            productCopy.excerpt = productCopy.excerpt.replace(/(<([^>]+)>)/gi, '');
                                            Object.assign(product, productCopy);
                                        }
                                    });
                                    _this.products = filteredProducts;
                                    resolve();
                                })];
                    }
                });
            });
        },
        // Filter funcs
        fetchFiltersForProductCategory: function () {
            return __awaiter(this, void 0, void 0, function () {
                var allFilters;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Running: fetchFiltersForProductCategory');
                            this.loadingFilters = true;
                            this.filters = [];
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryFilters)];
                        case 1:
                            allFilters = _a.sent();
                            return [2 /*return*/, new Promise(function (resolve) {
                                    if (!allFilters) {
                                        console.log('No filters found');
                                        _this.loadingFilters = false;
                                        resolve();
                                        return;
                                    }
                                    // Filter by selected category client-side
                                    var selectedCategoryIds = _this.search.terms.productCategory.map(function (id) { return _this.decodeTermId(id); });
                                    allFilters.forEach(function (node) {
                                        var _a, _b;
                                        // Skip if productAttribute is null
                                        if (!node.productAttribute) {
                                            return;
                                        }
                                        // Check if this attribute belongs to any of the selected categories
                                        var attributeCategoryIds = ((_b = (_a = node.taxProductCategories) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.map(function (cat) { return _this.decodeTermId(cat.id); })) || [];
                                        var belongsToSelectedCategory = selectedCategoryIds.length === 0
                                            || selectedCategoryIds.some(function (selectedId) { return attributeCategoryIds.includes(selectedId); });
                                        if (belongsToSelectedCategory) {
                                            _this.filters.push({
                                                can_update: false, // Simplified for now
                                                slug: node.slug.replaceAll('-', '_'),
                                                label: node.title,
                                                attributes: {
                                                    productAttribute: node.productAttribute,
                                                },
                                            });
                                        }
                                    });
                                    _this.loadingFilters = false;
                                    resolve();
                                })];
                    }
                });
            });
        },
        fetchFilteredSKUProducts: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            // Filter SKU Products
                            var filteredSKUProducts = _this.filteredSKUProducts; /* eslint-disable-line */
                            var parentProductIds = filteredSKUProducts.flatMap(function (x) { return (x.productParent ? x.productParent : ''); });
                            if (!parentProductIds) {
                                resolve([]);
                            }
                            resolve(parentProductIds);
                        })];
                });
            });
        },
        updateOptionsForFilter: function () {
            return __awaiter(this, void 0, void 0, function () {
                var filterOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('Running: updateOptionsForFilter');
                            if (this.search.terms.productCategory.length !== 1) {
                                console.log('Filters require a product category to be set');
                            }
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryFilterOptions)];
                        case 1:
                            filterOptions = _a.sent();
                            return [2 /*return*/, new Promise(function (resolve) {
                                    if (!filterOptions) {
                                        console.log('No filters found');
                                        resolve(null);
                                    }
                                    /*
                                     * Iterate through the filter options and convert any PHP style arrays to JS arrays.
                                     */
                                    filterOptions.forEach(function (filterOption) {
                                        filterOption.metaData.forEach(function (option) {
                                            if (!option.value) {
                                                return;
                                            }
                                            // Check if option.value is encased in [] and convert to array.
                                            if (option.value.startsWith('[')) {
                                                var optionCopy = __assign({}, option);
                                                optionCopy.value = JSON.parse(optionCopy.value);
                                            }
                                        });
                                    });
                                    resolve(filterOptions);
                                })];
                    }
                });
            });
        },
        assignUpdatedOptionsToFilters: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    console.log('Running: assignUpdatedOptionsToFilters');
                    return [2 /*return*/, new Promise(function (resolve) {
                            if (!options) {
                                resolve();
                            }
                            var _loop_1 = function (i) {
                                var element = _this.getUpdatableFilters[i];
                                var updatableFilterType = element.attributes.outputStyle[0]; // select or checkbox
                                var updatableFilterOptions = [];
                                element.attributes.options = updatableFilterOptions;
                                options.forEach(function (filterOptions) {
                                    if (!filterOptions) {
                                        return;
                                    }
                                    filterOptions.metaData.forEach(function (option) {
                                        if (!option.value) {
                                            return;
                                        }
                                        if (option.key === "product_attribute_".concat(element.slug)) {
                                            if (updatableFilterType === 'checkbox') {
                                                // console.log('checkbox: ', option.value);
                                            }
                                            else if (updatableFilterType === 'select') {
                                                // console.log('select: ', option.value);
                                            }
                                            var cleanValue_1 = '';
                                            // If option.value is an array, iterate through and clean all values.
                                            if (Array.isArray(option.value)) {
                                                option.value.forEach(function (value) {
                                                    cleanValue_1 = value.replaceAll('_', ' ');
                                                    if (!updatableFilterOptions.includes(cleanValue_1)) {
                                                        element.attributes.options.push(cleanValue_1);
                                                    }
                                                });
                                            }
                                            else {
                                                cleanValue_1 = option.value.replaceAll('_', ' ');
                                            }
                                            if (!updatableFilterOptions.includes(cleanValue_1)) {
                                                element.attributes.options.push(cleanValue_1);
                                            }
                                        }
                                    });
                                });
                            };
                            for (var i = 0; i < _this.getUpdatableFilters.length; i += 1) {
                                _loop_1(i);
                            }
                            resolve();
                        })];
                });
            });
        },
        handleOptionAsString: function () {
        },
        handleOptionAsArray: function () {
        },
        handleOptionAsNull: function () {
        },
        // DOM funcs
        getDefaultValuesFromDOM: function () {
            console.log('Running: getDefaultValuesFromDOM');
            this.API_URL = '/graphql';
            if (this.$root.dataset.defaultIndustry.length > 0) {
                this.search.terms.industry = this.$root.dataset.defaultIndustry.split(',');
            }
            if (this.$root.dataset.defaultProductCategory.length > 0) {
                this.search.terms.productCategory = this.$root.dataset.defaultProductCategory.split(',');
            }
            if (this.search.terms.productCategory.length > 1) {
                this.comparisonEnabled = false;
            }
            if (this.$root.dataset.defaultApplication.length > 0) {
                this.search.terms.application = this.$root.dataset.defaultApplication.split(',');
            }
        },
        updateMinMaxFilterValues: function (e) {
            var _a;
            console.log('Running: updateMinMaxFilterValues');
            var element = e.target;
            var type = element.dataset.minMaxType;
            var name = element.dataset.minMaxFilterName;
            var currentValue = (_a = this.search.filters[name]) !== null && _a !== void 0 ? _a : '|';
            var currentValueSplit = currentValue.split('|');
            if (type === 'min') {
                currentValueSplit[0] = element.value;
            }
            else if (type === 'max') {
                currentValueSplit[1] = element.value;
            }
            this.search.filters[name] = currentValueSplit.join('|');
        },
        // Getters for GraphQL strings
        get graphQLQuerySKUProducts() {
            return "query fetchSKUProducts {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT\n          }\n          first: 1000\n        ) {\n          nodes {\n            ... on Product {\n              databaseId\n              productParent\n            }\n          }\n        }\n      }";
        },
        get graphQLQueryProducts() {
            return "query fetchProducts {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT\n          }\n          first: 1000\n        ) {\n          nodes {\n            ... on Product {\n              databaseId\n              title\n              slug\n              uri\n              excerpt\n              featuredImage {\n                node {\n                  sourceUrl\n                  srcSet\n                }\n              }\n              taxProductCategories {\n                nodes {\n                  name\n                  id\n                }\n              }\n              taxIndustries {\n                nodes {\n                  name\n                  id\n                }\n              }\n              taxApplications {\n                nodes {\n                  name\n                  id\n                }\n              }\n            }\n          }\n        }\n      }";
        },
        get graphQLQueryFilters() {
            return "query GetFilters {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT_ATTRIBUTE\n          }\n          first: 10000\n        ) {\n          nodes {\n            ... on Page_attribute {\n              title\n              slug\n              productAttribute\n              taxProductCategories {\n                nodes {\n                  id\n                  name\n                }\n              }\n            }\n          }\n        }\n      }\n      ";
        },
        get graphQLQueryFilterOptions() {
            return "query GetFilterOptions {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT\n          }\n          first: 1000\n        ) {\n          nodes {\n            ... on Product {\n              databaseId\n              metaData( keysIn: [ ".concat(this.getUpdatableFilters.map(function (x) { return "\"product_attribute_".concat(x.slug, "\","); }), " ] ) {\n                key\n                value\n              }\n            }\n          }\n        }\n      }");
        },
        // Getters
        get formTaxonomyValues() {
            var string = '';
            // DISGUSTEN
            if (this.search.terms.productCategory.length < 1 && (this.search.terms.industry.length < 1) && (this.search.terms.application.length < 1)) {
                return string;
            }
            if (this.search.terms.productCategory.length > 0) {
                string += "{\n          field: ID,\n          taxonomy: TAX_PRODUCT_CATEGORY,\n          operator: IN,\n          terms: [".concat(this.search.terms.productCategory.map(function (x) { return "\"".concat(x, "\","); }), "]\n        }");
            }
            if (this.search.terms.industry.length > 0) {
                string += "{\n          field: ID,\n          taxonomy: TAX_INDUSTRY,\n          operator: IN,\n          terms: [".concat(this.search.terms.industry.map(function (x) { return "\"".concat(x, "\","); }), "]\n        }");
            }
            if (this.search.terms.application.length > 0) {
                string += "{\n          field: ID,\n          taxonomy: TAX_APPLICATION,\n          operator: IN,\n          terms: [".concat(this.search.terms.application.map(function (x) { return "\"".concat(x, "\","); }), "]\n        }");
            }
            string = "taxQuery: {\n        relation: AND\n        taxArray: [".concat(string, "]\n      }");
            return string;
        },
        get formMetaValues() {
            var _this = this;
            var string = '';
            if (this.search.filters) {
                Object.entries(this.search.filters).forEach(function (filter) {
                    var key = filter === null || filter === void 0 ? void 0 : filter[0];
                    var value = filter === null || filter === void 0 ? void 0 : filter[1];
                    var filterInfo = Array.from(_this.filters).filter(function (element) { return element['slug'] === key; }); /* eslint-disable-line */
                    var filterCompare = (filterInfo === null || filterInfo === void 0 ? void 0 : filterInfo[0]['attributes'].comparisonType[0].toUpperCase()) || ''; /* eslint-disable-line */
                    if (value === 'any' || value.length < 1) {
                        return;
                    }
                    if (filterCompare === 'BETWEEN') {
                        var val = value.split('|');
                        if (val === null || val === void 0 ? void 0 : val[1]) {
                            string = "".concat(string, "{\n                key: \"product_attribute_").concat(key, "\",\n                value: \"").concat(val[0], ",").concat(val[1], "\",\n                compare: BETWEEN,\n                type: DECIMAL\n              },");
                            // if (blah[1]) {
                            //   string = `${string}{
                            //     key: "product_attribute_${key}",
                            //     value: "${blah[1]}",
                            //     compare: LESS_THAN_OR_EQUAL_TO,
                            //     type: DECIMAL
                            //   },`;
                        }
                    }
                    else if (filterCompare === 'EQUAL_TO') {
                        if ((filterInfo === null || filterInfo === void 0 ? void 0 : filterInfo[0]['attributes'].outputStyle[0]) === 'truefalse') { /* eslint-disable-line */
                            // value is returned as a boolean
                            if (value) {
                                string = "".concat(string, "{\n                  key: \"product_attribute_").concat(key, "\",\n                  value: \"1\",\n                  compare: ").concat(filterCompare, "\n                },");
                            }
                        }
                        else {
                            string = "".concat(string, "{\n                key: \"product_attribute_").concat(key, "\",\n                value: \"").concat(value, "\",\n                compare: ").concat(filterCompare, "\n              },");
                        }
                    }
                    else if (value.length) {
                        if (typeof value === 'object') {
                            var valueAsArray = Array.from(value).join('|');
                            string = "".concat(string, "{\n                key: \"product_attribute_").concat(key, "\",\n                value: \"(?:").concat(valueAsArray, ")\\\\b\",\n                compare: REGEXP,\n                type: CHAR\n              },");
                        }
                        else {
                            string = "".concat(string, "{\n                key: \"product_attribute_").concat(key, "\",\n                value: \"(?:").concat(value, ")\\\\b\",\n                compare: REGEXP,\n                type: CHAR\n              },");
                        }
                    }
                });
            }
            return string;
        },
        get filteredSKUProducts() {
            return this.skuProductNodes.filter(function (value, index, self) { return index === self.findIndex(function (t) { return (t.productParent === value.productParent); }); });
        },
        get getUpdatableFilters() {
            return this.filters.filter(function (filter) { return filter.can_update; });
        },
        // Utility
        decodeTermId: function (encodedId) {
            // Decode base64 encoded ID like "dGVybToxMA==" to numeric ID like "10"
            try {
                var decoded = atob(encodedId);
                var match = decoded.match(/term:(\d+)/);
                return match ? match[1] : null;
            }
            catch (error) {
                console.error('Error decoding term ID:', error);
                return null;
            }
        },
        /* eslint-disable */
        graphQLRequest: function (queryString) {
            return __awaiter(this, void 0, void 0, function () {
                var response, data;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, fetch(this.API_URL, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    query: queryString,
                                }),
                            })];
                        case 1:
                            response = _d.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            data = _d.sent();
                            if (data.errors > 0) {
                                return [2 /*return*/];
                            }
                            if (((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.contentNodes) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                                return [2 /*return*/, data.data.contentNodes.nodes];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        /* eslint-enable */
    }); });
}
